import React, { useState, useEffect } from 'react';

const BUBBLE_MESSAGE = "Vous ne trouvez pas ce que vous cherchez ? Écrivez-nous sur WhatsApp !";
const SHOW_DURATION = 10000; // 10 seconds
const GAP_BEFORE_SECOND_SHOW = 10 * 60 * 1000; // 10 minutes

function WhatsAppFloatingButton() {
  const [showBubble, setShowBubble] = useState(false);

  useEffect(() => {
    const timers = [];

    // First appearance: right after entering the website
    setShowBubble(true);
    timers.push(setTimeout(() => setShowBubble(false), SHOW_DURATION));

    // Second appearance: 10 minutes later
    timers.push(setTimeout(() => {
      setShowBubble(true);
      timers.push(setTimeout(() => setShowBubble(false), SHOW_DURATION));
    }, GAP_BEFORE_SECOND_SHOW));

    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="whatsapp-float-wrapper">
      {showBubble && (
        <div className="whatsapp-bubble">
          <button
            type="button"
            className="whatsapp-bubble-close"
            onClick={() => setShowBubble(false)}
            aria-label="Fermer"
            title="Fermer"
          >
            <i className="fas fa-times"></i>
          </button>
          {BUBBLE_MESSAGE}
        </div>
      )}
      <a
        href="https://wa.me/212708786202"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        title="Contact us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
}

export default WhatsAppFloatingButton;